import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import { Mail, X } from 'lucide-react';
import { RootState } from '../store/Store';
import { apiAdapter } from '../config/adapters/api.adapter';
import './EmailVerificationBanner.scss';

export const EmailVerificationBanner = () => {
    const { user } = useSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [isClosing, setIsClosing] = useState(false);

    if (!user || user.isEmailVerified || !isVisible) return null;

    const resendVerification = async () => {
        try {
            setLoading(true);
            await apiAdapter.post('/auth/resend-verification', {});
            toast.success('Correo enviado correctamente');
        } catch (error: any) {
            if (error.status === 400) {
                toast.info('El correo ya ha sido verificado');
            } else {
                toast.error('Error al reenviar el correo');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => setIsVisible(false), 300);
    };

    return (
        <div className={`verification-banner-wrapper ${isClosing ? 'closing' : ''}`}>
            
            {/* Desktop Banner (Pill shaped, single line) */}
            <div className="desktop-banner">
                <div className="banner-content">
                    <div className="banner-text-group">
                        <Mail size={18} style={{ color: '#D97706', flexShrink: 0, marginTop: '2px' }} /> 
                        <span style={{ lineHeight: '1.4' }}>Tu correo electrónico aún no ha sido verificado.</span>
                        <span style={{ color: '#FCD34D', margin: '0 4px' }}>•</span>
                    </div>
                    
                    {loading ? (
                        <span className="d-flex align-items-center" style={{ color: '#B45309', fontSize: '13px' }}>
                            <Spinner size="sm" className="me-2" style={{ width: '0.8rem', height: '0.8rem' }} /> Enviando...
                        </span>
                    ) : (
                        <span className="resend-link" onClick={resendVerification}>
                            Reenviar enlace
                        </span>
                    )}
                </div>
                <button className="close-btn" onClick={handleClose} aria-label="Cerrar">
                    <X size={18} />
                </button>
            </div>

            {/* Mobile Banner (Native notification style) */}
            <div className="mobile-banner">
                <div className="toast-icon-wrapper">
                    <Mail size={18} strokeWidth={2.5} />
                </div>
                
                <div className="toast-content">
                    <div className="toast-title">Verifica tu correo electrónico</div>
                    <div className="toast-message">
                        Por seguridad, requiere verificación para usar todas las funciones.
                    </div>
                    {loading ? (
                        <div className="toast-action loading">
                            <Spinner size="sm" className="me-2" style={{ width: '12px', height: '12px' }} /> Enviando...
                        </div>
                    ) : (
                        <div className="toast-action" onClick={resendVerification}>
                            Reenviar enlace
                        </div>
                    )}
                </div>

                <button className="toast-close" onClick={handleClose} aria-label="Cerrar">
                    <X size={18} strokeWidth={2.5} />
                </button>
            </div>

        </div>
    );
};
